import { render } from "./CoBrandDashboard.vue?vue&type=template&id=56a84ea2&scoped=true"
import script from "./CoBrandDashboard.vue?vue&type=script&lang=js"
export * from "./CoBrandDashboard.vue?vue&type=script&lang=js"

import "./CoBrandDashboard.vue?vue&type=style&index=0&id=56a84ea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a84ea2"]])

export default __exports__